import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import './SignInForm.scss'
import { useSelector, useDispatch } from 'react-redux';
import { setCountryData as setCountryDataAction } from '../../common/features/user/userActions';
import DialCodePicker, { CountryCodeData } from "../dialCodePicker";
import countrycodedropdown from "../../common/assets/svg/dropdowncountrycode.svg";
import { getOtpRequest } from '../../common/features/auth/AuthActions';
import { useNavigate, useParams } from 'react-router';


type SignInFormData = {
  inputData: string;
  consent: boolean;
  marketingConsent: boolean;
};
interface SignInprops {
  otpScreen?: boolean;
  setOtpScreen?: any;
  setdata: any;
  onSubmit: any;
  signInPopupDesktop?: boolean;
  onClose?: any
}
const SignInForm: React.FC<SignInprops> = ({ otpScreen, setOtpScreen, setdata, onSubmit, signInPopupDesktop, onClose }) => {
  const {
    handleSubmit,
    control,
    getValues,
    watch,
    register,
    formState: { errors },
  } = useForm<SignInFormData>({
    mode: 'onSubmit',
    defaultValues: {
      inputData: '',
      consent: false,
      marketingConsent: false,

    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tableId, merchantType, merchantSlug, menuType } = useParams<any>();

  const isMobile = useSelector((state: any) => state?.navigation?.isMobile)
  const [isViewportMobile, setIsViewportMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false
  );
  const isMobileView = isMobile || isViewportMobile;
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [countrySelected, setCountrySelected] = useState<any>(false);
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);

  // Using country data from user reducer instead of local state
  const countryData = useSelector((state: any) => state.user.countryData);
  const slugFromLocalStorage = localStorage?.getItem("restaurant") && JSON?.parse(
    localStorage?.getItem("restaurant") || ""
  );

  // Function to update country data in the reducer
  const updateCountryData = (data: CountryCodeData) => {
    dispatch(setCountryDataAction(data));
  };
  const getOtpLoading = useSelector(
    (state: any) => state.auth.getOtpLoading
  );

  const getOtpSuccess = useSelector(
    (state: any) => state.auth.getOtpSuccess
  );
  const getOtpFailure = useSelector(
    (state: any) => state.auth.getOtpFailure
  );



  const consentwatch = watch("consent");
  const numberwatch = watch("inputData")


  // Mobile: /account/policies/{terms|PrivacyPolicy}; desktop: /account/Policies/{TermsOfUse|PrivacyPolicy}.
  const goToPolicy = (page: string) => {
    const slug = slugFromLocalStorage?.location ?? merchantSlug;
    const type = slugFromLocalStorage?.merchantType ?? merchantType;
    onClose();
    navigate(`/${type}/${slug}/account/${isMobileView ? 'policies' : 'Policies'}/${page}`);
  };

  const handleOnSubmit = (data: SignInFormData) => {
    setdata(data);
    const mobilePayload = {
      mobilePhone: countryData.code + '-' + data.inputData,
      sendOtpViaEmail: false
    };

    const emailPayload = {
      email: data.inputData,
      sendOtpViaEmail: true
    };
    
    dispatch(getOtpRequest(restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? emailPayload : mobilePayload));
    onSubmit()
  };
  const emailOtp = false;
  const inputError = !!errors?.inputData;


const fieldConfig = restaurantDetails?.platformConfiguration?.sendOtpViaEmail
  ? {
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: "Enter a valid email",
        },
      },
      maxLength: 32,
      transform: (v:any) => v, // no transform for email
    }
  : {
      rules: {
        required: "Mobile number is required",
        pattern: {
          value: /^[0-9]{10}$/,
          message: "Mobile number must be exactly 10 digits",
        },
      },
      maxLength: 10,
      transform: (v:any) => v.replace(/\D/g, ""), // strip non-digits
    };

  useEffect(() => {
    const handleResize = () => setIsViewportMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);





  return (
    <form onSubmit={handleSubmit(handleOnSubmit)} noValidate>
      {/* Mobile Number Field */}
      <div className="form-group-mobile">
        <label className={isMobileView ? 'input-label' : 'input-label-D'}>
         {restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? "Email Id" : "Mobile Number" }
          <span className="input-asterisk">*</span>
        </label>

        <div className="signin-popup-screen-Desktop">
          <div
            className={
              isMobileView
                ? 'phone-input-container'
                : signInPopupDesktop
                  ? 'phone-input-container-D-Popup'
                  : 'phone-input-container-D'
            }
          >
            {
              !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
              <div
                className="countryCodeContainer-new"
                onClick={() => {
                  setShowDialCodePicker(!showDialCodePicker);
                  setCountrySelected(!countrySelected);
                }}
              >
                <img src={countryData.flag} height="14px" width="21px" className="flag" />
                <img src={countrycodedropdown} alt="" className="country-code-dropdown" />
                <span className="countryCode">{countryData.code}</span>
              </div>
            }

            <div className="input-mobile">

              {/* {

                   <Controller
                  name="inputData"
                  control={control}
                  rules={{
                    required: 'Mobile number is required',
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: 'Mobile number must be exactly 10 digits',
                    },
                  }}
                  render={({ field }) => (
                    <input
                      className="phone-input"
                      type="text"
                      maxLength={10}
                      {...field}
                      onChange={e => {
                        const value = e.target.value.replace(/\D/g, '');
                        field.onChange(value);
                      }}
                    />
                  )}
                />

              } */}

              <Controller
                name="inputData"

                control={control}
                rules={fieldConfig.rules}
                render={({ field }) => (
                  <input
                   className="phone-input-signIn"
                    type="text"
                    style={{width: restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? isMobileView ?'100%':"500px" : '100%'}}
                    maxLength={fieldConfig.maxLength}
                     onFocus={() => {
        setShowDialCodePicker(false);
        setCountrySelected(false);
      }}
                    {...field}
                 onChange={(e) => {
        setShowDialCodePicker(false);
        setCountrySelected(false);
        field.onChange(fieldConfig.transform(e.target.value));
      }}

                  />
                )}
              />


            </div>

            <DialCodePicker
              showPicker={showDialCodePicker}
              setShowPicker={setShowDialCodePicker}
              setCountrySelected={setCountrySelected}
              setCountryData={updateCountryData}
              inputValue=""
              setIsMobile={true}
              onlyMobile={true}
              top={'100px'}
              width={isMobileView ? '70%' : '50%'}
            />
          </div>
          <div>
            {signInPopupDesktop && (
              <button
                type="submit"
                // className={isMobile ? "otp-button" : signInPopupDesktop ? "otp-button-Desktop-D-popup" : "otp-button-Desktop"}

                className={'otp-button-D-popup'}
                disabled={!numberwatch}
                style={{ opacity: !!numberwatch ? '100%' : '50%' }}
              >
                {getOtpLoading && (!getOtpSuccess || !getOtpFailure) ? 'Loading...' : '  Send OTP'}
              </button>
            )}
          </div>
        </div>
      </div>
      {errors.inputData && <p className="error-message">{errors.inputData.message}</p>}

      {/* Consent Checkbox */}
      <div className="consent-container" style={{ marginTop: inputError ? isMobileView ? "5px" : '-5px' : '22px' }}>
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            id="consent"
            className="consent-checkbox"
            {...register('consent')}
          />
          <label htmlFor="consent" className={isMobileView ? 'consent-text' : 'consent-text-D'}>
            {`I agree to receive ${restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 'Email' : 'SMS'} messages from us regarding order confirmations and order status updates. Message frequency varies. Message & data rates may apply. Reply STOP to opt out or HELP for assistance.`}
          </label>
        </div>
        <div className="checkbox-wrapper" style={{ marginTop: '12px' }}>
          <input
            type="checkbox"
            id="marketingConsent"
            className="consent-checkbox"
            {...register('marketingConsent')}
          />
          <label htmlFor="marketingConsent" className={isMobileView ? 'consent-text' : 'consent-text-D'}>
            {`I agree to receive promotional and marketing ${restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 'Email' : 'SMS'} messages from us, including special offers, discounts, and promotions. Consent is optional and not required to purchase. Message frequency varies. Message & data rates may apply. Reply STOP to opt out or HELP for assistance. View our `}
            <span onClick={() => goToPolicy('PrivacyPolicy')} className="clickhere-text">
              Privacy Policy
            </span>{' '}
            and{' '}
            <span onClick={() => goToPolicy(isMobileView ? 'terms' : 'TermsOfUse')} className="clickhere-text">
              Terms of Service
            </span>
            .
          </label>
        </div>
        {/* {errors.consent && (
          <p className="error-message" >
            {errors.consent.message}
          </p>
        )} */}
      </div>

      {!signInPopupDesktop && (
        <button
          type="submit"
          className={isMobileView ? 'otp-button' : 'otp-button-D'}
          disabled={!numberwatch}
          style={{ opacity: !!numberwatch ? '100%' : '50%' }}
        >
          {getOtpLoading && (!getOtpSuccess || !getOtpFailure) ? 'Loading...' : '  Send OTP'}
        </button>
      )}
    </form>
  );
};

export default SignInForm;
